import * as React from 'react';
import { Button } from 'antd';
import { ButtonsGroup } from '../Layout/components';

import './styles.scss';

interface FormProps {
  className?: string;
  displayFooter?: boolean;
  buttonSaveCaption?: string | undefined;
  onCancel: Function;
  onSubmit: Function;
}

interface FormState {
  isValidated: boolean;
}

class Form extends React.Component<FormProps, FormState> {

  public formEl: HTMLFormElement | Form | null;

  constructor(props: FormProps) {
    super(props);

    this.state = {
      isValidated: false
    };
  }

  public submitHandler = (event: any) => {
    event.preventDefault();

    if (this.validate()) {
      this.props.onSubmit(event);
    }

    this.setState({ isValidated: true });
  }

  public render() {
    const props = { ...this.props };
    delete props.displayFooter;
    const { displayFooter } = this.props;

    let classNames: string[] = [];
    if (props.className) {
      classNames = [props.className];
      delete props.className;
    }
    if (props.buttonSaveCaption) {
      delete props.buttonSaveCaption;
    }
    if (this.state.isValidated) {
      classNames.push('was-validated');
    }

    return (
      <form
        {...props}
        className={`ant-form ant-form-horizontal ${classNames.toString()}`}
        noValidate={true}
        ref={form => (this.formEl = form)}
        onSubmit={this.submitHandler}
      >
        {this.props.children}

        {displayFooter !== false &&
          <ButtonsGroup>
            <Button onClick={() => this.props.onCancel()}>Cancel</Button>
            <Button type="primary" onClick={this.submitHandler}>
              {this.props.buttonSaveCaption || `Save changes`}
            </Button>
          </ButtonsGroup>}
      </form>
    );
  }

  private validate = () => {
    if (this.formEl && this.formEl instanceof HTMLFormElement) {

      const formEl = this.formEl;
      const formLength = (formEl as HTMLFormElement).length;

      if (formEl.checkValidity() === false) {
        // first clear all error message elements
        for (let i = 0; i < formLength; i++) {
          this.setFormElementError(formEl[i], null);
        }
        // validate all form element
        for (let i = 0; i < formLength; i++) {
          // the i-th child of the form corresponds to the forms i-th input element
          const elem = formEl[i];
          if (elem && (elem as any).validity && !(elem as any).validity.valid) {
            this.setFormElementError(elem, (elem as any).validationMessage);
          }
        }

        return false;
      } else {
        // The form is valid, so we clear all the error messages
        for (let i = 0; i < formLength; i++) {
          this.setFormElementError(formEl[i], null);
        }

        return true;
      }
    }

    return true;
  }

  private setFormElementError(element: Element, errorMessage: string | null) {
    if (element) {
      const formItem = element.closest('.ant-form-item');
      const formItemControl = element.closest('.ant-form-item-control');
      if (formItem && formItemControl) {
        const errorLabel = formItem.querySelector('.ant-form-explain');
        if (errorLabel) {
          // zvýraznění inputu
          const formItemControlClass = formItemControl.getAttribute('class');
          let formItemControlClasses = (formItemControlClass ? formItemControlClass.toString().split(' ') : []);

          // chyba
          if (errorMessage !== null && errorMessage !== '') {
            // nastavím text chyby
            errorLabel.textContent = errorMessage;
            formItemControlClasses.push('has-error');
          } else {
            // vyčistím text chyby
            errorLabel.textContent = '';
            formItemControlClasses = [...formItemControlClasses].filter((c: string) => c !== 'has-error');
          }

          // nastaví clasu
          formItemControl.setAttribute('class', formItemControlClasses.join(' '));
        }
      }
    }
  }
}

export default Form;


// WEBPACK FOOTER //
// ./src/components/Form/Form.tsx